<template>
  <div class="canvas__wrapper" />
</template>

<script>

import * as PIXI from 'pixi.js';

const farmUrl = require('@/assets/img/homepage.jpg');
const piantaUrl = require('@/assets/img/pianta.png');
const stefanoUrl = require('@/assets/img/stefano.png');
const chiaraUrl = require('@/assets/img/chiara.png');
const nuvola1Url = require('@/assets/img/nuvola1.png');

export default {
  name: 'Ivano',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.initCanvas();
  },
  methods: {
    initCanvas() {
      this.app = new PIXI.Application({
        // resizeTo: window,
        width: 1920,
        height: 1920,
      });
      document.querySelector('.canvas__wrapper').appendChild(this.app.view);
      this.app.view.classList.add('canvas');

      this.animationBaseSpeed = 0.04;
      this.animationBaseAmount = 0.05;
      this.objects = [];

      // this.app.loader.add('farm', farmUrl).load((loader, resources) => {
      //   // This creates a texture from a 'bunny.png' image
      //   this.farm = new PIXI.Sprite(resources.farm.texture);

      //   // Setup the position of the farm
      //   this.farm.x = this.app.renderer.width / 2;
      //   this.farm.y = this.app.renderer.height / 2;

      //   // Rotate around the center
      //   this.farm.anchor.x = 0.5;
      //   this.farm.anchor.y = 0.5;

      //   // Add the this.farm to the scene we are building
      //   this.app.stage.addChild(this.farm);

      //   // Listen for frame updates
      //   this.app.ticker.add(() => {
      //     // each frame we spin the this.farm around a bit
      //     // this.farm.rotation += 0.01;
      //     // this.farm.position.x = this.app.view.width / 2 + Math.random() * 10;
      //     // this.farm.position.y = this.app.view.height / 2 + Math.random() * 10;
      //   });
      //   this.resize();
      // });

      this.cheat = '';
      this.cheatTimeout = null;

      this.farm = PIXI.Sprite.from(farmUrl);
      this.app.stage.addChild(this.farm);
      this.farm.anchor.x = 0;
      this.farm.anchor.y = 0;
      this.farm.zIndex = 0;

      this.createObject(piantaUrl, 150, 1280, 1, 0.02, 1, 0.1, 1);
      this.createObject(piantaUrl, 1500, 1080, 0.7, 0.01, 1, 0.12, 1);

      this.stefano = this.createObject(stefanoUrl, 1130, 1130, 1, 0, 1, 0.09, 1);
      this.chiara = this.createObject(chiaraUrl, 800, 1130, 1, 0, 1, 0.07, 1);

      this.nuvola = this.createObject(nuvola1Url, -100, 230, 1, 0, 0, 0, 0);

      this.app.ticker.add(() => {
        if (this.earthquake) {
          this.farm.position.x = Math.random() * 10;
          this.farm.position.y = Math.random() * 10;
        }

        this.objects.forEach((obj) => {
          obj.rotation = Math.sin(this.app.ticker.lastTime * obj.rotSpeed * this.animationBaseSpeed) * this.animationBaseAmount * obj.rotAmt;
          obj.scale.y = obj.baseScale + (1 + (Math.sin(this.app.ticker.lastTime * obj.scaleSpeed * this.animationBaseSpeed)) / 2) * this.animationBaseAmount * obj.scaleAmt;
          if (this.earthquake) {
            obj.position.x = obj.startPos.x + Math.random() * 10;
            obj.position.y = obj.startPos.y + Math.random() * 10;
          }
        });

        this.nuvola.position.x += 0.5;
        if (this.nuvola.position.x > this.app.view.width + 200) {
          this.nuvola.position.x = -200;
        }
      });

      this.resize();
      window.addEventListener('resize', () => {
        this.resize();
      });
      window.addEventListener('keydown', (e) => {
        this.checkKey(e);
      });
    },
    toggleEarthquake() {
      this.earthquake = !this.earthquake;
    },
    toggleBear() {
      console.log('BEAR');
    },
    checkKey(e) {
      // console.log(e);
      this.cheat += e.key;
      if (this.cheat === 'quake') {
        this.toggleEarthquake();
        this.cheat = '';
      }
      if (this.cheat === 'bear') {
        this.toggleBear();
        this.cheat = '';
      }
      clearTimeout(this.cheatTimeout);
      this.cheatTimeout = setTimeout(() => {
        this.cheat = '';
      }, 2000);
    },
    createObject(url, x, y, scale, rotSpeed, rotAmt, scaleSpeed, scaleAmt) {
      const obj = PIXI.Sprite.from(url);
      this.app.stage.addChild(obj);
      obj.anchor.x = 0.5;
      obj.anchor.y = 1;
      obj.position.x = x;
      obj.position.y = y;
      obj.startPos = {
        x,
        y,
      };
      obj.baseScale = scale;
      obj.scale.x = scale;
      obj.scale.y = scale;
      obj.rotSpeed = rotSpeed;
      obj.scaleSpeed = scaleSpeed;
      obj.rotAmt = rotAmt;
      obj.scaleAmt = scaleAmt;
      this.objects.push(obj);
      return obj;
    },
    calculatePosition(_x, _y) {
      const pos = {};
      pos.x = 1920 / (this.app.view.width / _x);
      pos.y = 1920 / (this.app.view.height / _y);
      return pos;
    },
    resize() {
      if (window.innerWidth > window.innerHeight) { // HORIZONTAL
        this.app.view.style.width = '100%';
        this.app.view.style.height = 'auto';
      } else {
        this.app.view.style.width = 'auto';
        this.app.view.style.height = '100%';
      }

      // this.farm.width = size;
      // this.farm.height = size;

      // this.farm.position.x = this.app.view.width / 2;
      // this.farm.position.y = this.app.view.height / 2;
    },
  },
};
</script>

<style lang="scss" scoped>

/deep/ .canvas {
  // width: 100%;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  // height: 100vh;
  // display: none;
}

.canvas__wrapper {

  position: fixed;
  z-index: -100;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  // display: grid;
  // place-content: center;
  // position: fixed;
  // top: 0;
  // left: 0;
  // height: 100vh;
  // width: 100vw;
}

</style>
